import { render, staticRenderFns } from "./SubModalBase.vue?vue&type=template&id=0c66c925&scoped=true&"
import script from "./SubModalBase.vue?vue&type=script&lang=ts&"
export * from "./SubModalBase.vue?vue&type=script&lang=ts&"
import style0 from "./SubModalBase.vue?vue&type=style&index=0&id=0c66c925&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c66c925",
  null
  
)

export default component.exports